import FieldDripFeed from '../../Fields/DripFeed';
import FieldCancel from '../../Fields/Cancel';
import filterDripFeed from './filters/drip_feed';
import filterCancel from './filters/cancel';

export const getOptionsFields = (form, providerForm, modal) => {
  const fields = [
    {
      component: FieldDripFeed,
      filter: filterDripFeed(form, providerForm, modal),
    },
    {
      component: FieldCancel,
      filter: filterCancel(form, providerForm),
    },
  ]

  return fields
    .filter((field) => field.filter)
    .map((field) => field.component)
}
